import React from "react"

import {
  Select as SelectPrimitive,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue
} from "@/components/ui"
type SelectProps = {
  className?: string
  options: {
    label: string
    value: string
  }[]
  value: string
  onChange: (value: string) => void
  placeholder?: string
  disabled?: boolean
}

export const Select: React.FC<SelectProps> = ({
  className = "",
  options,
  value,
  onChange,
  placeholder,
  disabled
}) => {
  return (
    <SelectPrimitive value={value} onValueChange={onChange} disabled={disabled}>
      <SelectTrigger className={className}>
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent side="bottom" className="max-h-[250px]">
        {options.map((option) => (
          <SelectItem key={option.value} value={option.value}>
            {option.label}
          </SelectItem>
        ))}
      </SelectContent>
    </SelectPrimitive>
  )
}
